import { DialogComponent } from '@theme/dialog';

/**
 * A custom element that manages the size guide drawer.
 *
 * @extends {DialogComponent}
 */
class SizeGuideDrawerComponent extends DialogComponent {
  open() {
    this.showDialog();
  }

  close() {
    this.closeDialog();
  }

  async selectSize() {
    const target = document.querySelector('variant-picker[data-pdp="true"]') ?? document.querySelector('variant-picker');

    await this.closeDialog();

    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}

if (!customElements.get('size-guide-drawer-component')) {
  customElements.define('size-guide-drawer-component', SizeGuideDrawerComponent);
}
